import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  messages: [],
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(
  state: State,
  { messages }: Boundaries["getConversationMessages"]["success"],
): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    messages,
  };
}

function handleFailure(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.getConversationMessagesRequested]: handleRequest,
    [events.getConversationMessagesSucceeded]: handleSuccess,
    [events.getConversationMessagesFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isGetConversationMessagesRequestFailure() {
      return getState().request.isFailure;
    },
    isGetConversationMessagesRequestPending() {
      return getState().request.isPending;
    },
    isGetConversationMessagesRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getChatMessages() {
      return getState().messages;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
